import { Component } from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Comprobar from './components/Comprobar';
import CambioContrasena from './components/CambioContrasena';
import TiposRecuperar from './components/TiposRecuperar';
import ModificarRecuperacion from './components/ModificarRecuperacion';
import RecuperarContrasena from './components/RecuperarContrasena';
import Opciones from './components/Opciones';
import AccountHelp from './components/Help';
import 'rsuite/dist/rsuite.min.css';
import 'styles/common.sass';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        {/* Home */}
        <Route exact path='/' component={Comprobar} />

        {/* Modificar Contraseña */}
        <Route exact path='/comprobar' component={Comprobar} />
        <Route path='/cambiocontrasena/:id' component={CambioContrasena} />

        {/* Datos de Recuperación */}
        <Route exact path='/tiposrecuperacion' component={TiposRecuperar} />
        <Route path='/modificacionrecuperacion/:id' component={ModificarRecuperacion} />

        {/* Recuperar Contraseña */}
        <Route exact path='/recuperar' component={RecuperarContrasena} />
        <Route path='/opciones/:id' component={Opciones} />
        
        {/* Ayuda */}
        <Route exact path='/help' component={AccountHelp} />
      </Layout>
    );
  }
}
